<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="isEdit ? '编辑评估材料' : '提交评估材料'"
      :visible.sync="isOpen"
      width="580px"
      :close-on-click-modal="false"
      :before-close="handleDialogClose"
    >
      <div v-if="!isShowLoading" :class="{'form-content-wrapper':formData.targetLableRecordForms.length > 2}">
        <vue-scroll :ops="ops">
          <div class="scroll-content">
            <el-form
              ref="formDataRom"
              :model="formData"
              :rules="formDataRules"
              label-width="110px"
            >
              <!--<el-form-item-->
                <!--v-if="isInClubSystem"-->
                <!--label="自评得分"-->
                <!--required-->
                <!--:prop="`targetSelfScoreForm.score`"-->
                <!--:rules="[requiredItem('自评得分'), maxScoreValidate]"-->
              <!--&gt;-->
                <!--<el-input-number-->
                  <!--v-model="formData.targetSelfScoreForm.score"-->
                  <!--:min="0"-->
                  <!--:max="maxScore"-->
                  <!--label="自评得分"-->
                <!--&gt;</el-input-number>-->
              <!--</el-form-item>-->

              <el-form-item label="证明材料" :error="uploadErroeMsg" :rules="{required: isNeedFile ? true : false}">
                <el-upload
                  class="yioks-form-item"
                  :action="uploadPath"
                  :on-remove="handleRemoveFile"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccessFiler"
                  multiple
                  :limit="9"
                  :on-exceed="handleExceed"
                  :file-list="uploadFileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    <a
                      v-if="tempFile.url"
                      :href="$yioksConfig.transferBaseOnly(tempFile.url)"
                      :download="tempFile.name"
                      class="temp-file"
                      >下载本条需要提交材料的模板文件：<span
                        class="title"
                        :title="`点击下载模板文件：${tempFile.name}`"
                        >{{ tempFile.name }}</span
                      ></a>
                      <a style="color: #666;">单个上传文件大小不能超过50M,最多上传9个文件。</a>
                  </div>
                </el-upload>
              </el-form-item>

              <template v-if="formData.targetLableRecordForms.length">
                <el-divider>补充信息内容</el-divider>
                <div
                  v-for="(item, index) in formData.targetLableRecordForms"
                  :key="index"
                >
                  <el-form-item
                    :prop="`targetLableRecordForms.${index}.lableContent`"
                    :rules="[requiredItem('补充信息')]"
                  >
                    <slot name="label">
                      <div class="label-wrapper">
                        <p :title="item.lableName" style="line-height:25px">{{ item.lableName }}</p>
                      </div>
                    </slot>
                    <el-input
                      v-model="item.lableContent"
                      type="textarea"
                      :rows="3"
                      class="yioks-form-item"
                      :placeholder="item.lableInfo || '请填写补充信息内容'"
                    ></el-input>
                  </el-form-item>
                </div>
              </template>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="empty-box" v-if="isShowLoading">
        <yioks-loading v-if="isShowLoading"></yioks-loading>
      </div>
      <div slot="footer" class="footer-btn-group">
        <el-button type="primary" :disabled="isShowLoading" :loading="addbtnLoading" @click="handleDialogFormAction(true)"
          >确 定</el-button
        >
        <el-button type="danger" :disabled="isShowLoading" :loading="addbtnLoading" @click="handleDialogFormAction(false)"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postTargetSubmit,
  putTargetSubmit,
  deleteTargetSubmit,
  getSecondTargetFileAndLabel,
} from "@/api/performance";
import { requiredItem } from "@/assets/js/formRules";
import { ops } from "@/utils/scrollIndialog";
import storage from '@/utils/storage'
import mixinAppConfig from '@/mixin/mixinAppConfig';

export default {
  mixins: [mixinAppConfig],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      required: true,
    },

    defaultFormData: {
      type: Object,
      default: () => {
        return {
          // ... 默认值
        };
      },
    },

    isDetailsNeed: {
      type: false,
      default: false,
      required: false,
    },

    isEdit: {
      type: Boolean,
      default: false,
      required: false,
    },

    stageUuid: {
      type: String,
      default: "",
      required: false,
    },
  },

  data() {
    return {
      ops,
      requiredItem,
      // uploadPath: "/api/zuxie/guozi/upload/jixiao",
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      formData: {
        fileFormList: [
          // {
          //   fileName: '',
          //   fileType: '',
          //   fileUrl: '',
          //   md5: '',
          //   stageUuid: '',
          //   targetUuid: '',
          //   // uuid: '',
          // }
        ],
        targetLableRecordForms: [
          {
            groupUuid: "",
            lableContent: "",
            lableUuid: "",
            stageUuid: "",
            userUuid: "",
            uuid: "",
            youthUuid: "",
          },
        ],
        targetSelfScoreForm: {
          score: 0,
          stageUuid: "",
          targetSecondlyUuid: "",
          // uuid: '',
        },
      },
      isNeedFile:1,
      formDataRules: {},
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      fileListChangedFlag: false,
      tempFile: {},
      targetUuid: "",
      isShowLoading: false,
      userRole: storage.get('userInfo').userRole,
      addbtnLoading: false,
    };
  },

  computed: {

    maxScore() {
      const { targetSecondlyTotalScore } = this.defaultFormData;
      return targetSecondlyTotalScore;
    },

    maxScoreValidate() {
      return {
        required: false,
        validator: (rule, value, callBack) => {
          if (value > this.maxScore) {
            callBack(
              new Error(`自评得分不能超过该指标最大分值：${this.maxScore}分`)
            );
          } else {
            callBack();
          }
        },
        trigger: "change",
      };
    },

    // 指标组uuid
    groupUuid() {
      const { groupUuid } = this.defaultFormData;
      return groupUuid;
    },

    // 二级指标uuid
    targetSecondlyUuid () {
      const { uuid } = this.defaultFormData;
      return uuid;
    },


  },

  created() {
    this.setDataWhenDialogOpen();
  },

  methods: {
    // 设置表单原始内容
    setFormDataFormate() {
      const {
        groupUuid,
        targetName,
        uuid: targetUuid,
        scoreUuid,
        score,
        targetTemplateFileUrl,
        targetFileName,
      } = this.defaultFormData;
      const targetLableListVoList = this.targetLableListVoList;
      const fileList = this.fileList;
      this.targetUuid = targetUuid;
      let { targetSelfScoreForm, fileFormList, targetLableRecordForms } =
        this.formData;
      //  处理模板数据对象
      this.tempFile = {
        url: targetTemplateFileUrl,
        name: targetFileName,
      };
      // 处理自评得分对象
      targetSelfScoreForm = {
        score: score ? score : 0, // 默认为0的情况下会短路该项校验规则
        stageUuid: this.stageUuid,
        targetSecondlyUuid: targetUuid,
      };
      // 存在已提交数据(编辑)
      if (scoreUuid) targetSelfScoreForm.uuid = scoreUuid;
      this.$set(this.formData, "targetSelfScoreForm", targetSelfScoreForm);
      //  处理量化指标文件列表
      if (targetLableListVoList && targetLableListVoList.length) {
        targetLableRecordForms = targetLableListVoList.map((item) => {
          const {
            groupUuid,
            lableContent,
            uuid: lableUuid,
            targetSecondlyUuid: targetUuid,
            youthUuid,
            lableName,
            lableRecordUuid,
            lableInfo
          } = item;
          const stageUuid = this.stageUuid;
          const backObj = {
            groupUuid,
            lableContent,
            lableUuid,
            stageUuid,
            targetSecondlyUuid: targetUuid,
            youthUuid,
            lableName,
            lableInfo
          };
          // 存在已提交数据(编辑)
          if (lableRecordUuid) backObj.uuid = lableRecordUuid;
          return backObj;
        });
        this.$set(
          this.formData,
          "targetLableRecordForms",
          targetLableRecordForms
        );
      } else {
        this.$set(this.formData, "targetLableRecordForms", []);
      }
      // 处理已上传文件列表
      if (fileList && fileList.length) {
        this.uploadFileList = [];
        this.uploadFileList = fileList.map((item) => {
          const { fileName, fileUrl, uuid, fileType } = item;
          return {
            name: fileName,
            url: fileUrl,
            id: uuid,
            meta: item,
          };
        });
      }
    },

    //  关闭弹窗
    handleDialogClose() {
      if(this.isShowLoading) return
      this.setDialogStatus(false);
    },

    // 设置弹窗状态
    setDialogStatus(flag) {
      this.$emit("update:isOpen", flag);
    },

    //  设置弹窗回调事件
    setCallBackFunction(dialogStatus, confirmStatus) {
      if (!dialogStatus) this.handleDialogClose();
      this.$emit("closeDialogCallBack", dialogStatus, confirmStatus);
    },

    // 弹窗表单操作按钮
    handleDialogFormAction(status) {
      if (status) {
        this.$refs.formDataRom.validate((valid) => {
          if (valid) {
            this.addbtnLoading = true
            this.uploadErroeMsg = "";
            // 编辑状态下不校验原始证明材料
            if (!this.formData.fileFormList.length && !this.isEdit && this.isNeedFile) {
              this.addbtnLoading = false
              this.uploadErroeMsg = "请上传证明材料";
              return; // 无证明材料不允许 提交
            }
            // 编辑状态下需要检测原始文件和修改文件列表同时不为空，避免用户删除全部文件而不上传新文件
            if (this.isEdit) {
              this.addbtnLoading = false
              if (!this.uploadFileList_edit.length && !this.uploadFileList.length && this.isNeedFile) {
                this.uploadErroeMsg = "请上传证明材料";
                return; // 无证明材料不允许 提交
              }
            }
            let requestName = this.isEdit ? putTargetSubmit : postTargetSubmit;
            //  编辑模式下修改上传的文件列表 （仅上传新增的文件）
            if (this.isEdit) {
              this.addbtnLoading = true
              if (this.uploadFileList_edit.length) {
                this.$set(
                  this.formData,
                  "fileFormList",
                  this.uploadFileList_edit
                );
              } else {
                // 用户没有新增加文件 - 清空提交文件列表
                this.$set(this.formData, "fileFormList", []);
              }
            }
            const submitData = this.formData;
            requestName(submitData)
              .then((res) => {
                this.addbtnLoading = false
                if (res.code) {
                  this.$message.error(res.msg);
                  this.setCallBackFunction(true, true);
                  return;
                }
                this.setCallBackFunction(false, true);
              })
              .catch((err) => {
                this.addbtnLoading = false
                this.setCallBackFunction(true, true);
                console.error("err", err);
              });
          } else {
            this.addbtnLoading = false
            this.uploadErroeMsg = "";
            if (!this.formData.fileFormList.length && this.isNeedFile) {
              this.addbtnLoading = false
              this.uploadErroeMsg = "请上传证明材料";
              return; // 无证明材料不允许 提交
            }
            console.error("校验未通过");
          }
        });
      } else {
        this.handleDialogClose();
      }
    },

    // 移除文件
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        deleteTargetSubmit(uuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
      this.$set(this.formData, "fileFormList", this.uploadFileList);
      if(this.isEdit) {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },

    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        targetSecondlyUuid: this.targetUuid,
        stageUuid: this.stageUuid,
        fileType: suffix
      };
      if (this.isEdit) {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
      this.$set(this.formData, "fileFormList", this.uploadFileList);
    },

    // 上传文件检测
    beforeUpload(file) {
      // const fileReg = /^.*\.(pptx|ppt)$/i
      // const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
      }
      // if (fileType) {
      //   this.$message.error("暂不支持PPT上传");
      // }
      return fileLimit;
    },

    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传9个文件，本次上传已经超过了限制。`);
    },


    setDataWhenDialogOpen() {
      const getFileAndLableListParams = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        targetSecondlyUuid: this.targetSecondlyUuid,
      }
      this.isShowLoading = true;
      getSecondTargetFileAndLabel(getFileAndLableListParams)
        .then(res => {
          this.isShowLoading = false;
          if(res.code) {
            this.$message.error(res.msg);
            return
          }
          const { fileList, targetLableListVoList,isNeedFile } = res;
          this.targetLableListVoList = targetLableListVoList;
          this.isNeedFile = isNeedFile;
          this.fileList = fileList;
          this.setFormDataFormate();
        })
        .catch(err => {
          this.isShowLoading = false;
          console.error('err', err)
        })
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.temp-file
  color #606266
  .title
    color $green_color !important
.label-wrapper
  width 340px
  /*p*/
  /*  white-space nowrap*/
  /*  overflow hidden*/
  /*  text-overflow ellipsis*/
.form-content-wrapper
  height 380px
  .scroll-content
    margin-right 20px

.empty-box
  height: 240px
</style>

<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.el-upload__tip
  display: flex
  flex-direction column
  a
    line-height: 20px !important
</style>
